import Vue from 'vue'
import { toBytes, toInt, toDecimal } from "../utils/format"

Vue.filter('bytes', (value, decimals) => {
    return toBytes(value, decimals)
})

Vue.filter('int', (value) => {
    return toInt(value)
})

Vue.filter('decimal', (value, decimals) => {
    return toDecimal(value, decimals)
})